import { Flex, Text } from '@chakra-ui/react';
import { faFile } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ISubmissionFile } from '@publishing-engine/domain/models';
import FileViewerButtonText from 'src/components/Submission/FileViewerButtonText';

export const EditorialAttachments = ({
  attachments,
  submissionContextId
}: {
  attachments?: ISubmissionFile[];
  submissionContextId: string;
}) =>
  !!attachments?.length && (
    <Flex flexDirection="column">
      {attachments.map(attachment => (
        <Flex justifyContent="space-between" key={attachment?.referenceName}>
          <Flex gap={2} alignItems="center">
            <FontAwesomeIcon icon={faFile} />
            <Text
              textStyle="textBody"
              wordBreak={'break-word'}
              whiteSpace={'normal'}
            >
              {attachment?.referenceName}
            </Text>
            <FileViewerButtonText
              file={attachment}
              submissionContextId={submissionContextId}
              textStyle="textBody"
              flexShrink={0}
            >
              View
            </FileViewerButtonText>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
